import { GenerateShowStatusEnum } from '@/pages/Home/components/AudioList/AudioItem/audioItemState';
import { GenerateStatus } from '@/service/type';
import { fetchM3U8Duration } from '@/utils/hls';
import { useEffect, useState } from 'react';
import { AnyEventObject, StateValue } from 'xstate';

interface UseAudioStreamingStatusProps {
  generateShowStatus: StateValue;
  send: (event: AnyEventObject) => void;
  m3u8Url?: string;
  totalSongTime: number;
}

export function useAudioStreamingStatus({ generateShowStatus, send, m3u8Url, totalSongTime }: UseAudioStreamingStatusProps) {
  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (generateShowStatus === GenerateShowStatusEnum.Generating && !intervalId && m3u8Url) {
      if (m3u8Url?.endsWith('.m3u8')) {
        intervalId = setInterval(async () => {
          const { totalDuration, isEnded } = await fetchM3U8Duration(m3u8Url);
          if (isEnded) {
            clearInterval(intervalId!);

            send({ type: 'UPDATE_PROGRESS', progressPercentage: 100 });
            send({ type: 'GENERATED' });
          } else {
            const percentage = Math.floor((totalDuration / totalSongTime) * 100);

            send({ type: 'UPDATE_PROGRESS', progressPercentage: percentage });
          }
        }, 3000);
      } else {
        send({ type: 'UPDATE_PROGRESS', progressPercentage: 100 });
        send({ type: 'GENERATED' });
      }
    }

    if (generateShowStatus !== GenerateShowStatusEnum.Generating && intervalId) {
      clearInterval(intervalId);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [m3u8Url, generateShowStatus]);
}
